import { useAppSelector } from 'hooks/reduxHooks'
import { isCurrentDeviceMobileOrTablet } from 'selectors/configSelectors'

export function useIsMobileOrTablet(): boolean {
  return useAppSelector(isCurrentDeviceMobileOrTablet)
}
